module.exports = __webpack_public_path__ + "static/media/like-icon.ce180ad4.svg";